/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { Component, OnInit } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';
import { take } from 'rxjs/operators';

import {
    IAviDiffGridConfig,
    IAviDiffGridRow,
} from 'ng/modules/data-grid/components/avi-diff-grid/avi-diff-grid.types';

import * as l10n from './log-cinematic-section-datascript.l10n';
import { TrafficLogCinematicStore } from '../../traffic-logs/traffic-log-cinematic/traffic-log-cinematic.store';

import './log-cinematic-section-datascript.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *     Component for displaying the Datascript section in a traffic log cinematic view.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'log-cinematic-section-datascript',
    templateUrl: './log-cinematic-section-datascript.component.html',
})
export class LogCinematicSectionDatascriptComponent implements OnInit {
    public readonly l10nKeys = l10nKeys;

    public readonly datascriptInfo$ = this.logCinematicStore.datascriptInfo$;

    public datascriptDiffGridConfig: IAviDiffGridConfig;

    public diffGridRows: IAviDiffGridRow[] = [];

    constructor(
        private readonly logCinematicStore: TrafficLogCinematicStore,
        private readonly l10nService: L10nService,
    ) {
        this.l10nService.registerSourceBundles(dictionary);
    }

    /** @override */
    public ngOnInit(): void {
        this.logCinematicStore.datascriptInfo$
            .pipe(take(1))
            .subscribe(({ datascript_error_trace: datascriptErrorTrace }) => {
                if (datascriptErrorTrace) {
                    const { error: right, stack_trace: left } = datascriptErrorTrace;

                    this.diffGridRows = [{
                        left,
                        right,
                    }];
                }
            });

        this.datascriptDiffGridConfig = {
            leftField: {
                label: this.l10nService.getMessage(l10nKeys.datascriptErrorStackTraceLabel),
            },
            rightField: {
                label: this.l10nService.getMessage(l10nKeys.datascriptErrorLabel),
            },
            layout: {
                placeholderMessage: this.l10nService.getMessage(l10nKeys.emptyListPlaceholderLabel),
            },
            noDiff: true,
        };
    }

    /**
     * Wrapper for closing the log c-view. Used upon filter clickings.
     */
    public closeCinematicView(): void {
        this.logCinematicStore.closeCinematic();
    }
}
